import { useMemo } from 'react';
import { ApolloProvider } from '@apollo/client/react';
import createApolloClient from 'utils/apollo_client';

const Apollo = ({ apiUrl, children }) => {
  const client = useMemo(() => createApolloClient(apiUrl), [apiUrl]);
  return <ApolloProvider client={client}>{children}</ApolloProvider>;
};

export default Apollo;
